export const useAppearanceStore = defineStore(
  "appearanceStore",
  () => {
    const sideFilterMenu = ref({
      isShown: false,
    });
    const modals = ref({
      ad: {
        wasShown: false,
      },
      leadCapture: {
        wasShown: false,
      },
      wheel: {
        wasShown: false,
      },
    });
    const account = ref({
      customer: {
        isEdited: false,
      },
      contacts: {
        isEdited: false,
      },
      password: {
        isEdited: false,
      },
    });

    const setModalHasShown = (modalName) => {
      modals.value[modalName].wasShown = true;
    };

    return {
      sideFilterMenu,
      modals,
      account,
      setModalHasShown,
    };
  },
  {
    persist: {
      storage: persistedState.cookiesWithOptions({
        maxAge: 86400,
      }),
      paths: ["modals"],
    },
  },
);
